var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isPageLoading
    ? _c("div", [
        _vm.hasAdminAccess && (_vm.user != null || _vm.currentuser != null)
          ? _c(
              "div",
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-title",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoggedInUserActive,
                            expression: "!isLoggedInUserActive"
                          }
                        ]
                      },
                      [
                        _c("label", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.$t("msguserisnotactive")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tabs",
                  {
                    attrs: {
                      "fixed-tabs": "",
                      "background-color": "#6b6b6b",
                      dark: ""
                    },
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  [
                    _c("v-tabs-slider", { attrs: { color: "#1976d2" } }),
                    _vm._v(" "),
                    _vm._l(_vm.categoryMasters, function(cmitem) {
                      return _c(
                        "v-tab",
                        {
                          key: cmitem.categoryId,
                          on: {
                            change: function($event) {
                              return _vm.tabChanged(cmitem.categoryId)
                            }
                          }
                        },
                        [
                          cmitem.categoryName == "Maintainence Group"
                            ? _c("span", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("maintgrps")) +
                                    "\n                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          cmitem.categoryName == "User Companies"
                            ? _c("span", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("companies")) +
                                    "\n                "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "v-tabs-items",
                  {
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  _vm._l(_vm.categoryMasters, function(cmitem) {
                    return _c(
                      "v-tab-item",
                      { key: cmitem.categoryId },
                      [
                        _c(
                          "v-card",
                          [
                            _c("v-data-table", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isLoggedInUserActive,
                                  expression: "isLoggedInUserActive"
                                }
                              ],
                              attrs: {
                                headers: _vm.headers(cmitem.categoryName),
                                items: _vm.filteredCategoryData,
                                search: _vm.search,
                                "footer-props": {
                                  itemsPerPageOptions: _vm.tableItemsPerPage,
                                  itemsPerPageText: _vm.rowsperpage
                                },
                                options: _vm.options
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "top",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-dialog",
                                          {
                                            attrs: { "max-width": "500px" },
                                            model: {
                                              value: _vm.dialogDelete,
                                              callback: function($$v) {
                                                _vm.dialogDelete = $$v
                                              },
                                              expression: "dialogDelete"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-card",
                                              {
                                                attrs: { light: "", flat: "" }
                                              },
                                              [
                                                _c(
                                                  "v-card-title",
                                                  { staticClass: "headline" },
                                                  [
                                                    _vm._v(
                                                      "Are you sure you want to delete this item?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-card-actions",
                                                  [
                                                    _c("v-spacer"),
                                                    _vm._v(" "),
                                                    _c("v-progress-circular", {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.deleteinProgress,
                                                          expression:
                                                            "deleteinProgress"
                                                        }
                                                      ],
                                                      attrs: {
                                                        indeterminate: "",
                                                        color: "primary"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: !_vm.deleteinProgress,
                                                            expression:
                                                              "!deleteinProgress"
                                                          }
                                                        ],
                                                        attrs: {
                                                          color:
                                                            "blue darken-1",
                                                          text: ""
                                                        },
                                                        on: {
                                                          click: _vm.closeDelete
                                                        }
                                                      },
                                                      [_vm._v("Close")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: !_vm.deleteinProgress,
                                                            expression:
                                                              "!deleteinProgress"
                                                          }
                                                        ],
                                                        attrs: {
                                                          color:
                                                            "blue darken-1",
                                                          text: ""
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.deleteItemConfirm
                                                        }
                                                      },
                                                      [_vm._v("OK")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-spacer")
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-toolbar",
                                          { attrs: { flat: "", dense: "" } },
                                          [
                                            _c(
                                              "v-dialog",
                                              {
                                                attrs: { "max-width": "500px" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "mb-2",
                                                                  attrs: {
                                                                    color:
                                                                      "primary",
                                                                    dark: ""
                                                                  }
                                                                },
                                                                "v-btn",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("new")
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: _vm.dialog,
                                                  callback: function($$v) {
                                                    _vm.dialog = $$v
                                                  },
                                                  expression: "dialog"
                                                }
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.dialog &&
                                                          _vm.statusmessages
                                                            .length > 0,
                                                        expression:
                                                          "dialog && statusmessages.length > 0"
                                                      }
                                                    ],
                                                    attrs: { id: "error" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-alert",
                                                      {
                                                        attrs: {
                                                          value: true,
                                                          type: "error"
                                                        }
                                                      },
                                                      [
                                                        _c("div", [
                                                          _c(
                                                            "ul",
                                                            _vm._l(
                                                              _vm.statusmessages,
                                                              function(
                                                                status,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "li",
                                                                  {
                                                                    key: index
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                        " +
                                                                        _vm._s(
                                                                          status.message
                                                                        ) +
                                                                        "\n                                                    "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-card",
                                                  [
                                                    _c(
                                                      "v-card-title",
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "headline"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.formTitle
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-spacer"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.close(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("close")]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card-text",
                                                      [
                                                        _c(
                                                          "v-container",
                                                          [
                                                            _c(
                                                              "v-row",
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: false,
                                                                        expression:
                                                                          "false"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      cols:
                                                                        "12",
                                                                      sm: "8",
                                                                      md: "8"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      {
                                                                        attrs: {
                                                                          items:
                                                                            _vm.categoryMasters,
                                                                          label: _vm.$t(
                                                                            "category"
                                                                          ),
                                                                          "item-text":
                                                                            "categoryName",
                                                                          "item-value":
                                                                            "categoryId",
                                                                          disabled:
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.selectedTab,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.selectedTab = $$v
                                                                          },
                                                                          expression:
                                                                            "selectedTab"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols:
                                                                        "12",
                                                                      sm: "8",
                                                                      md: "8"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      {
                                                                        staticStyle: {
                                                                          "background-color":
                                                                            "#ffffcc"
                                                                        },
                                                                        attrs: {
                                                                          items:
                                                                            _vm.plants,
                                                                          label:
                                                                            _vm.$t(
                                                                              "plant"
                                                                            ) +
                                                                            " *",
                                                                          "item-text":
                                                                            "plant",
                                                                          "item-value":
                                                                            "id"
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            _vm.changePlant
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.selecttedplant,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.selecttedplant = $$v
                                                                          },
                                                                          expression:
                                                                            "selecttedplant"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols:
                                                                        "12",
                                                                      sm: "8",
                                                                      md: "8"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            (_vm.selectedTab ==
                                                                            1
                                                                              ? _vm.$t(
                                                                                  "company"
                                                                                )
                                                                              : _vm.selectedTab ==
                                                                                2
                                                                              ? _vm.$t(
                                                                                  "maintgrp"
                                                                                )
                                                                              : _vm.selectedTab ==
                                                                                3
                                                                              ? _vm.$t(
                                                                                  "businessunit"
                                                                                )
                                                                              : _vm.$t(
                                                                                  "discipline"
                                                                                )) +
                                                                            " *"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .editedItem
                                                                              .value,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.editedItem,
                                                                              "value",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "editedItem.value"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols:
                                                                        "12",
                                                                      sm: "6",
                                                                      md: "6"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label: _vm.$t(
                                                                            "otherinfo"
                                                                          )
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .editedItem
                                                                              .otherInfo,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.editedItem,
                                                                              "otherInfo",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "editedItem.otherInfo"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card-actions",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              color:
                                                                "blue darken-1",
                                                              text: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.close(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("cancel")
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-spacer"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass: "mb-2",
                                                            attrs: {
                                                              color: "primary",
                                                              dark: ""
                                                            },
                                                            on: {
                                                              click: _vm.save
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("save")
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-divider", {
                                              staticClass: "mx-4",
                                              attrs: { inset: "", vertical: "" }
                                            }),
                                            _vm._v(" "),
                                            _c("v-text-field", {
                                              attrs: {
                                                "append-icon": "mdi-magnify",
                                                label: _vm.$t("searchall"),
                                                "single-line": "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: _vm.search,
                                                callback: function($$v) {
                                                  _vm.search = $$v
                                                },
                                                expression: "search"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "item.action",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-2",
                                            attrs: { small: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.editItem(item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                mdi-pencil\n                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { small: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteItem(item)
                                              }
                                            }
                                          },
                                          [_vm._v(" mdi-delete ")]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "no-data",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              border: "right",
                                              "colored-border": "",
                                              type: "error",
                                              elevation: "2"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$t("norecordsfound")
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _vm.user != null || _vm.currentuser != null
          ? _c(
              "div",
              [
                _c(
                  "v-alert",
                  {
                    attrs: {
                      outlined: "",
                      type: "warning",
                      prominent: "",
                      border: "left"
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("accessdenied")) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ])
    : _c(
        "div",
        [
          _c("v-progress-linear", {
            attrs: {
              indeterminate: "",
              color: "teal",
              rounded: "",
              height: "8"
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-403e02f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-403e02f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlantSpecificData.vue
// module id = null
// module chunks = 